export default __webpack_public_path__ + "static/media/core-alt-lockup.66c91d2b.svg";